export default "__VITE_ASSET__a621aee8__"